import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home/index.vue';
import search from '@/views/search/search.vue';
import detail from '@/views/detail/index.vue';
import List from '@/views/dragon-tiger-table/list';
import StockDetail from '@/views/dragon-tiger-table/detail/stock-detail';
import SalesDetail from '@/views/dragon-tiger-table/detail/sales-department';
import Login from '@/views/login/index.vue';
import Send from '@/views/guba/send/index.vue';
import ViewDetail from '@/views/guba/detail/index.vue';
import Protocol from '@/views/protocol/index.vue';
import MarginTradingShortSelling from '@/views/rzrq/index.vue';
import TradeList from '@/views/rzrq/tradeList.vue';
import PlateDetail from '@/views/plateDetail/index.vue';
import PlateConstituentStock from '@/views/plate-constituent-stock/index.vue';
import StockRzrq from '@/views/stockRzrq/index.vue';
import StockRzrqList from '@/views/stockRzrq/list/index.vue';
import MarkIndex from '@/views/markIndex/index.vue';
import BkRank from '@/views/markIndex/bkRank/index.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            keepAlive: true,
        },
    },
    {
        path: '/:market/:code.html',
        name: 'index',
        component: Home,
        meta: {
            keepAlive: true,
        },
    },
    {
        path: '/search.html',
        name: 'search',
        component: search,
        meta: {
            keepAlive: false,
        },
    },
    {
        path: '/detail/:market/:code/:type/:id.html',
        name: 'detail',
        component: detail,
        meta: {
            keepAlive: false,
        },
    },
    {
        path: '/send/:market/:code/send.html',
        name: 'send',
        component: Send,
        meta: {
            keepAlive: false,
        },
    },
    {
        path: '/viewDetail/:market/:code/:id.html',
        name: 'viewDetail',
        component: ViewDetail,
        meta: {
            keepAlive: false,
        },
    },
    {
        path: '/protocol/:market/:code/:id.html',
        name: 'protocol',
        component: Protocol,
        meta: {
            keepAlive: false,
        },
    },
    // {
    //   path: '/list',
    //   component: List,
    //   children: [{
    //     path: 'league',
    //     name: 'league',
    //     component: DragonList,
    //     meta: {
    //       keepAlive: true
    //     }
    //   }, {
    //     path: 'sales',
    //     name: 'sales',
    //     component: SalesList,
    //     meta: {
    //       keepAlive: true
    //     }
    //   }],
    //   meta: {
    //     keepAlive: false
    //   }
    // }
    {
        path: '/stock-list.html',
        component: List,
        meta: {
            title: '龙虎榜单',
            keepAlive: true,
        },
    },
    {
        path: '/rzrq.html',
        component: MarginTradingShortSelling,
        meta: {
            title: '融资融券',
            keepAlive: true,
        },
    },
    {
        path: '/rzrq-list.html',
        component: TradeList,
        meta: {
            title: '融资融券',
            keepAlive: false,
        },
    },
    {
        path: '/rzrq/:stock/:innerCode.html',
        component: StockRzrq,
        meta: {
            title: '',
            keepAlive: false,
        },
    },
    {
        path: '/rzrq-stock-list.html',
        component: StockRzrqList,
        meta: {
            title: '',
            keepAlive: false,
        },
    },
    {
        path: '/stock/detail/:id.html',
        name: 'stockdetail',
        component: StockDetail,
        meta: {
            title: '龙虎榜',
            keepAlive: false,
        },
    },
    {
        path: '/department/detail/:id.html',
        name: 'departmentDetail',
        component: SalesDetail,
        meta: {
            title: '营业部详情',
            keepAlive: false,
        },
    },
    {
        path: '/login.html',
        name: 'login',
        component: Login,
        meta: {
            keepAlive: false,
        },
    },
    {
        path: '/markIndex.html',
        name: 'markIndex',
        component: MarkIndex,
        meta: {
            title: '大盘指数',
            keepAlive: false,
        },
    },
    {
        path: '/bkRank.html',
        name: 'bkRank',
        component: BkRank,
        meta: {
            title: '板块排行',
            keepAlive: false,
        },
    },
    {
        path: '/plate/:typeCode/:prodCode.html',
        name: 'PlateDetail',
        component: PlateDetail,
    },
    {
        path: '/plateConstituentStock/:block/:code.html', // 板块成分股列表页
        name: 'plateConstituentStock',
        component: PlateConstituentStock,
        meta: {
            keepAlive: false,
        },
    },
];

const router = new VueRouter({
    mode: 'history',
    base: '/wap/',
    routes,
});

export default router;
